"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CollegeSavingsPageOne;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _CollegeSavingsWizardFormControls = require("./CollegeSavingsWizardFormControls");
var _utils = require("../../middleware/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function CollegeSavingsPageOne() {
  var _children$, _children$2, _children$3, _children$4, _children$5;
  var {
    values: {
      contributionPercent,
      savings,
      numOfKids,
      collegeTerm,
      children
    },
    errors,
    touched,
    values,
    setFieldValue,
    setFieldTouched
  } = (0, _formik.useFormikContext)();
  (0, _react.useEffect)(() => {
    for (var i = 1; i <= numOfKids; i++) {
      var _children;
      setFieldValue("children[".concat(i - 1, "].collegeTerm"), collegeTerm);
      setFieldValue("children[".concat(i - 1, "].fundPercent"), contributionPercent);
      setFieldValue("children[".concat(i - 1, "].collegeAge"), Math.max((0, _utils.parseCurrencyString)(null, children === null || children === void 0 || (_children = children[i - 1]) === null || _children === void 0 ? void 0 : _children.childAge) + 1, 18));
    }
  }, [contributionPercent, numOfKids, collegeTerm, children[0].childAge, (_children$ = children[1]) === null || _children$ === void 0 ? void 0 : _children$.childAge, (_children$2 = children[2]) === null || _children$2 === void 0 ? void 0 : _children$2.childAge, (_children$3 = children[3]) === null || _children$3 === void 0 ? void 0 : _children$3.childAge, (_children$4 = children[4]) === null || _children$4 === void 0 ? void 0 : _children$4.childAge, (_children$5 = children[5]) === null || _children$5 === void 0 ? void 0 : _children$5.childAge]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_CollegeSavingsWizardFormControls.NumberOfChildren, {
    errors: errors,
    touched: touched,
    numOfKids: numOfKids,
    comboScenarioInd: true,
    setFieldValue: setFieldValue,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_CollegeSavingsWizardFormControls.ChildrenAges, {
    errors: errors,
    touched: touched,
    numOfKids: numOfKids,
    setFieldValue: setFieldValue,
    setFieldTouched: setFieldTouched,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_CollegeSavingsWizardFormControls.ContributionPercent, {
    errors: errors,
    touched: touched,
    values: values,
    contributionPercent: contributionPercent,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_CollegeSavingsWizardFormControls.CollegeTerm, {
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_CollegeSavingsWizardFormControls.Savings, {
    values: values,
    errors: errors,
    touched: touched,
    savings: savings,
    setFieldValue: setFieldValue
  }));
}